import { render, staticRenderFns } from "./ghostModal.vue.pug?vue&type=template&id=586ae675&lang=pug&"
import script from "./ghostModal.vue.js?vue&type=script&lang=js&"
export * from "./ghostModal.vue.js?vue&type=script&lang=js&"
import style0 from "./ghostModal.vue.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports